import React from "react";
import { ReactComponent as Remove } from "../Global Icons/CancelButton.svg";

const ImageShowerModal = ({ file,onClick }) => {
  return (
    <div className="upload-image-shower">
      <img src={file} alt=""></img>
      <div
        // onClick={() => {
        //   mainState((prevData) => ({ ...prevData, url: "" }));
        //   fileState("");
        // }}
        onClick={onClick}
      >
        <Remove></Remove>
      </div>
    </div>
  );
};

export default ImageShowerModal;
